import Alert from 'flarum/components/Alert';
import humanTime from 'flarum/utils/humanTime';

export default function redisFailedAlert() {
    if (app.data.resources[0].attributes['redisError']) {

        class ContainedAlert extends Alert {
            view() {
                const vdom = super.view();

                vdom.children = [<div className="container">{vdom.children}</div>];

                return vdom;
            }
        }

        m.mount(
            $('<div/>').insertBefore('#content')[0],
            ContainedAlert.component({
                dismissible: false,
                type: 'error',
                children: app.translator.trans('reflar-recache.forum.redis.error_alert', {
                    time: <strong>{humanTime(new Date(app.data.resources[0].attributes['redisError']))}</strong>
                }),
            })
        );
    }
}